import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import Box from '@tds/core-box';

import { Link as NavLink } from 'react-router-dom';
import { colorTelusPurple } from '@tds/core-colours';

export const TableWrapper = styled.table`
  width: 100%;
  border: 1px solid #ededed;
  @media screen and (max-width: 992px) {
    overflow-y: scroll;
    display: block;
  }
`;

export const Th = styled.td`
  color: #595859;
  background-color: #e2e2e2;
  padding: 0.4rem;
  text-align: center;
  cursor: pointer;
  font-weight: 500;
`;

export const Link = styled(NavLink)`
  color: #2a2c2e;
  text-decoration: none;
  font-weight: 400;
  cursor: pointer;
`;

export const Td = styled.td`
  padding: 0.5rem;
  text-align: center;
  ${props =>
    props.actionStyles &&
    css`
      display: ${props.actionsDisplay};
      justify-content: center;
    `}
`;

Td.propTypes = {
  actionStyles: PropTypes.bool,
  actionsDisplay: PropTypes.string
};

Td.defaultProps = {
  actionStyles: false,
  actionsDisplay: 'flex'
};

const getColor = props => {
  if (props.isParent) {
    return '#f9fafa';
  }
  if (props.isChildRow) {
    return '#fff9ef';
  }
  if (props.isOdd) {
    return '#f9f1ff';
  }
  return '#ffffff';
};

export const Tr = styled.tr`
  background-color: ${props => getColor(props)};
  cursor: ${props => props.isParent && 'pointer'};
`;

Tr.propTypes = {
  isParent: PropTypes.bool,
  isChildRow: PropTypes.bool,
  isOdd: PropTypes.number
};

export const Heading = styled.div`
  margin: 32px 8px;
  font-size: 32px;
  color: ${colorTelusPurple};
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  min-height: 20px;
  margin-top: 1rem;
`;

export const PaginationContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid #dadada;
  border-radius: 25px;
  box-shadow: 1px 1px 5px 0 #d5d5d5;
  height: 48px;
  margin: 8px 0 28px !important;
  padding: 1rem;
`;

export const Page = styled(Box)`
  width: 48px;
  height: 32px;
  border: 2px solid rgb(255, 255, 255);
  border-radius: 25px;
  text-align: center;
  padding: 2px 6px;
  margin: 2px;
  font-weight: 500;
  text-decoration: none !important;
  color: ${props => (props.item === props.currentPage ? '#ffffff' : '#49166d')};
  background-color: ${props =>
    props.item === props.currentPage
      ? 'rgb(75, 40, 109) !important'
      : '#ffffff'};
`;

Page.propTypes = {
  item: PropTypes.number,
  currentPage: PropTypes.number
};

Page.defaultProps = {
  item: null,
  currentPage: 1
};

export const Expired = styled.p`
  color: red;
`;

export const MessageApproved = styled.div`
  background: #66cc00;
  color: white;
  font-weight: bold;
  padding: 3px 5px;
  border-radius: 5px;
  font-size: 12px;
  margin: 2px;
`;

export const MultiSiteTag = styled.div`
  background: ${props => props.color};
  color: white;
  text-align: center;
  font-weight: bold;
  padding: 2px;
  width: 60px;
  font-size: 12px;
  border-radius: 2px;
  margin-left: 8px;
`;

MultiSiteTag.propTypes = {
  color: PropTypes.string
};

MultiSiteTag.defaultProps = {
  color: '#4c2b6c'
};
